import { render } from "./EditCollectionPowerupsModal.vue?vue&type=template&id=1b449cf2&scoped=true"
import script from "./EditCollectionPowerupsModal.vue?vue&type=script&lang=js"
export * from "./EditCollectionPowerupsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b449cf2"]])

export default __exports__